import { Pipe, PipeTransform } from '@angular/core';

import { colorMappingSnow } from '../constants/constants';

@Pipe({ name: 'colorMappingSnow' })
export class ColorMappingSnowPipe implements PipeTransform {
  transform(value: number, greenTableDesign: boolean) {
    return colorMappingSnow(value, greenTableDesign);
  }
}
